import React from 'react';
import MasterAdminApp from './MasterAdminApp';

const AdminApp = () => {
  return (
    <MasterAdminApp />
  );
};

export default AdminApp;
